export default __webpack_public_path__ + "static/media/MyBookings_01.9defab32.jpg";